












































import { AuthStoreHelper, RootStoreHelper } from '../../core/mixins';
import moment from 'moment';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { ColorsList } from '../../core/utils';

@Component({
    components: {
        
    }
})
export default class ChatbotHeader extends Mixins(RootStoreHelper, AuthStoreHelper) {
  deleteChatHistoryBtnColor: string = ColorsList.red_pastel;
  
  @Emit()
  clearConversation(){}

  closeModal(){
    this.$_chatbotTogglePanel();
  }
   
}
